import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import MuiTableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { ITableHead, ITableColumn } from './Interfaces';
import { columnTitlesToBeCentered } from './constants';

const TableHead = ({ classes, order, orderBy, onRequestSort, columns } : ITableHead) => (
  <MuiTableHead>
    <TableRow className={classes.headerRow}>
      {columns.map(({ field, title, sorting = true, width, sortable, columnStyles }: ITableColumn) => {
        const commonsCellProps = {
          style: width ? { width: `${width}%` } : {},
          className: classes.headerCell,
          key: field,
          'data-seleniumid': `${field}-header-cell`,
        };
        return ((onRequestSort && sorting) ? (
          <TableCell
            {...commonsCellProps}
            align={columnTitlesToBeCentered.includes(title) ? 'center' : 'left'}
            sortDirection={orderBy === field ? order : false}
          >
            {
              sortable
                ? (
                  <TableSortLabel
                    style={columnStyles?.tableSortLabel}
                    active={orderBy === field}
                    direction={orderBy === field ? order : 'asc'}
                    onClick={() => onRequestSort(field)}
                  >
                    {title}
                  </TableSortLabel>
                )
                : <>{title}</>
            }
          </TableCell>
        ) : (
          <TableCell {...commonsCellProps} align={columnTitlesToBeCentered.includes(title) ? 'center' : 'left'}>{title}</TableCell>));
      },
      )}
    </TableRow>
  </MuiTableHead>
);

export default TableHead;
